// Fallback statique synchronisé avec backend/server.py (PACKAGES + UPSELLS).
// Utilisé si l'API /packages est indisponible — garantit que la section ne soit jamais vide.

export const FALLBACK_PACKAGES = [
    {
        id: "decouverte",
        name: "Découverte",
        tagline: "Testez le studio",
        price: 90,
        unit: "séance",
        duration: "1h",
        description: "1h studio + setup pro",
        features: [
            "1h de studio professionnel",
            "Setup micros & casques inclus",
            "Technicien sur place",
            "Fichiers bruts haute qualité",
        ],
    },
    {
        id: "abonnement",
        name: "Abonnement",
        tagline: "Publiez chaque semaine",
        price: 350,
        unit: "mois",
        duration: "3h / semaine",
        description: "3h/sem + contenu mensuel",
        features: [
            "3h de studio par semaine",
            "Contenu mensuel inclus (shorts, posts)",
            "Accompagnement éditorial",
            "Priorité de réservation",
        ],
    },
    {
        id: "premium",
        name: "Premium",
        tagline: "Clé en main",
        price: 620,
        unit: "séance",
        duration: "1/2 journée",
        description: "1/2 journée + stratégie + contenu",
        features: [
            "Demi-journée complète en studio",
            "Session stratégie personnalisée",
            "Pack contenu (épisode + shorts + visuels)",
            "Miniatures YouTube premium",
            "Accompagnement prioritaire",
        ],
    },
];

export const FALLBACK_UPSELLS = [
    { id: "extra_hour", name: "Heure supplémentaire", price: 100, description: "Prolongez votre session — idéal pour la formule Découverte" },
    { id: "short_supp", name: "Short supplémentaire", price: 30, description: "Un short vertical en plus (Reels/TikTok)" },
    { id: "montage", name: "Montage vidéo", price: 75, description: "Montage vidéo additionnel" },
    { id: "branding", name: "Branding podcast", price: 225, description: "Identité visuelle (logo, cover, templates)" },
    { id: "miniature", name: "Miniature YouTube", price: 15, description: "Miniature pro optimisée CTR" },
];
